// React
import React from 'react';
import {
  Col,
  Row,
  Card,
  Form,
  Input,
  Label,
  CardBody,
  Collapse,
  Accordion,
  CardFooter,
  AccordionItem,
} from 'reactstrap';

// Containers Injection
import {
  PageWrapper,
  SelectInput,
  convertEventSelectToTarget,
  SelectInputWithSearchApiAssociates,
} from '../../containers/componentsInjection';

// Utils
import classnames from 'classnames';
import UiContent from '../../../../components/Common/UiContent';

export const DeliveryTermPage = ({
  col1,
  col2,
  t_col1,
  t_col2,
  history,
  sellers,
  createData,
  validation,
  organizations,
}) => {
  return (
    <PageWrapper title="Termo de Responsabilidade de Entrega de Cartão">
      <Row>
        <Col xxl={12}>
          <Card>
            <Form
              autoComplete="off"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <CardBody className="p-4">
                <Row>
                  <Col md={6}>
                    <div className="mb-3">
                      <Label htmlFor="sellerInput" className="form-label">
                        Corretor
                      </Label>
                      <SelectInput
                        isClearable
                        className="form-control"
                        inputId="sellerInput"
                        value={validation.values.sellerInput}
                        onChange={(eventInput) => {
                          validation.handleChange(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );
                        }}
                        onBlur={(eventInput) => {
                          validation.handleBlur(
                            convertEventSelectToTarget(
                              'sellerInput',
                              eventInput
                            )
                          );
                        }}
                        options={createData(sellers) || []}
                        placeholder="Todos"
                        invalid={
                          !!(
                            validation.touched.sellerInput &&
                            validation.errors.sellerInput
                          )
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col md={12}>
                    <div className="mt-3 ">
                      <UiContent />
                      <Accordion id="default-accordion-example">
                        <AccordionItem>
                          <h2 className="accordion-header" id="headingOne">
                            <button
                              className={classnames(
                                'accordion-button fw-semibold',
                                {
                                  collapsed: !col1,
                                }
                              )}
                              type="button"
                              onClick={t_col1}
                              style={{ cursor: 'pointer' }}
                            >
                              Por Organização
                            </button>
                          </h2>

                          <Collapse
                            isOpen={col1}
                            className="accordion-collapse"
                            id="collapseOne"
                          >
                            <div className="accordion-body">
                              <Col md={8} className="mb-3">
                                <div>
                                  <Label
                                    for="saleAtInput"
                                    className="form-label"
                                  >
                                    Período de venda
                                  </Label>
                                  <div className="d-flex justify-content-center align-items-center">
                                    <Input
                                      type="date"
                                      id="periodStarts"
                                      value={validation.values.periodStarts}
                                      onBlur={validation.handleBlur}
                                      onChange={validation.handleChange}
                                      invalid={
                                        !!(
                                          validation.touched.periodStarts &&
                                          validation.errors.periodStarts
                                        )
                                      }
                                    />

                                    <span className="m-2">a</span>

                                    <Input
                                      type="date"
                                      id="periodEnds"
                                      value={validation.values.periodEnds}
                                      onBlur={validation.handleBlur}
                                      onChange={validation.handleChange}
                                      invalid={
                                        !!(
                                          validation.touched.periodEnds &&
                                          validation.errors.periodEnds
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </Col>
                              <Col md={12}>
                                <div className="mb-3">
                                  <Label
                                    className="form-label"
                                    htmlFor="organizationInput"
                                  >
                                    Organização
                                  </Label>
                                  <SelectInput
                                    isClearable
                                    inputId="organizationInput"
                                    value={validation.values.organizationInput}
                                    className="form-control"
                                    onChange={(eventInput) => {
                                      if (!eventInput) {
                                        validation.handleChange({
                                          target: {
                                            name: 'organizationInput',
                                            value: {
                                              label: '',
                                              value: '',
                                            },
                                          },
                                        });
                                      } else {
                                        validation.handleChange(
                                          convertEventSelectToTarget(
                                            'organizationInput',
                                            eventInput
                                          )
                                        );
                                      }
                                    }}
                                    onBlur={(eventInput) => {
                                      validation.handleBlur(
                                        convertEventSelectToTarget(
                                          'organizationInput',
                                          eventInput
                                        )
                                      );
                                    }}
                                    options={createData(organizations)}
                                    placeholder="Todas"
                                    invalid={
                                      !!(
                                        validation.touched.organizationInput &&
                                        validation.errors.organizationInput
                                      )
                                    }
                                  />
                                </div>
                              </Col>
                            </div>
                          </Collapse>
                        </AccordionItem>
                        <AccordionItem>
                          <h2 className="accordion-header" id="headingTwo">
                            <button
                              className={classnames(
                                'accordion-button fw-semibold',
                                {
                                  collapsed: !col2,
                                }
                              )}
                              type="button"
                              onClick={t_col2}
                              style={{ cursor: 'pointer' }}
                            >
                              Individual
                            </button>
                          </h2>

                          <Collapse
                            isOpen={col2}
                            className="accordion-collapse"
                          >
                            <div className="accordion-body">
                              <Label
                                className="form-label"
                                htmlFor="searchInput"
                              >
                                Associado
                              </Label>
                              <SelectInputWithSearchApiAssociates
                                className="js-example-basic-single mb-0"
                                validation={validation}
                                invalid={
                                  !!(
                                    validation.touched.searchInput &&
                                    validation.errors.searchInput
                                  )
                                }
                              />
                            </div>
                          </Collapse>
                        </AccordionItem>
                      </Accordion>
                    </div>
                  </Col>
                </Row>
              </CardBody>

              <CardFooter>
                <Col md={12}>
                  <div className="text-end d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-link"
                      style={{
                        marginRight: '10px',
                      }}
                      onClick={() => {
                        history.push('/relatorios');
                      }}
                    >
                      Voltar
                    </button>
                    <button type="submit" className="btn btn-primary">
                      Gerar Relatório
                    </button>
                  </div>
                </Col>
              </CardFooter>
            </Form>
          </Card>
        </Col>
      </Row>
    </PageWrapper>
  );
};
